import React, { Fragment, Component } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";

import axios from "axios";
import { ToastContainer, toast } from "react-toast";
import { withTranslation } from "react-i18next";

//import { createMuiTheme, ThemeProvider } from '@material-ui/core';
const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const token = localStorage.getItem("AccessToken");
const BackendURL = window.BackendURLCmk;
class AddContact extends Component {
  constructor(props) {
    super(props);

    this.onChangeState = this.onChangeState.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      open: true,

      id: "",
      nom: "",
      prenom: "",
      email: "",
      adresse: "",
      tel_portable: "",
      tel_fix: "",
      tel_3: "",
      tel_4: "",
      tel_5: "",
      commentaire: "",
      redirectToReferrer: false,
    };
  }

  componentDidMount() {
    const cpte = localStorage.getItem("compte");
    const post = localStorage.getItem("poste");
    this.setState({ poste: post });
    this.setState({ compte: cpte });
  }
  setOpen() {
    this.setState({ open: false });
  }

  onChangeState = (key, value) => {
    this.setState({
      ...this.state,
      [key]: value,
    });
  };

  getAllcontact = async () => {
    var lien = window.location.href;
    // console.log(lien);
    const var2 = lien.split("/");
    //console.log("kien ici", var2[2]);
    var var4 = var2[2].split(":");
    // console.log("kien ici", var4[0]);
    var config = {
      headers: {
        Authorization: token,
      },
    };
    const result = await axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/CarnetAdresseIPBXV3API?compte=${compte}&poste=${poste}`,
        config
      )
      .then((res) => {
        const data = res.data.carnet_adresse;
        localStorage.setItem("tabcontact", JSON.stringify(data));

        // For displaying Data
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  };
  showCustom = () =>
    toast("Nouveau contact ajouté avec succès", {
      backgroundColor: "#27d0b2",
      color: "#ffffff",
    });
  onSubmit(e) {
    e.preventDefault();
    const fieldTel = document.getElementById("tel_portable");
    const fieldNom = document.getElementById("nom_prenom");

    if (!this.state.nom || !this.state.tel_portable) {
      if (!this.state.nom) {
        fieldNom?.focus();
        fieldNom?.classList.remove("focus:ring-green-500");

        fieldNom?.classList.add("focus:ring-red-500");
      } else {
        fieldTel?.focus();
        fieldTel?.classList.remove("focus:ring-green-500");

        fieldTel?.classList.add("focus:ring-red-500");
      }

      return;
    } else {
      fieldTel?.classList.remove("focus:ring-red-500");
      fieldNom?.classList.remove("focus:ring-red-500");
    }
    var config = {
      headers: {
        Authorization: token,
      },
    };
    axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/CRUDContactCarnetAdresseIPBXV3API?compte=${compte}&poste=${poste}&action=create&id&nom_prenom=${this.state.nom}&prenom=${this.state.prenom}&email=${this.state.email}&adresse=${this.state.adresse}&tel_portable=${this.state.tel_portable}&tel_fix=${this.state.tel_fix}&tel_3=${this.state.tel_3}&tel_4=${this.state.tel_4}&tel_5=${this.state.tel_5}&commentaire=${this.state.commentaire}`,
        config
      )
      .then((res) => {
        this.setState({
          id: "",
          nom_prenom: "",
          prenom: "",
          email: "",
          adresse: "",
          tel_portable: "",
          tel_fix: "",
          tel_3: "",
          tel_4: "",
          tel_5: "",
          commentaire: "",
        });
        this.showCustom();
        this.getAllcontact();
        this.setState({ redirectToReferrer: true });
        this.props.handleClose(); //close after submit
        this.props.toggle(); //rerender contact component
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          toast.error("Ce contact existe déja");
        }
      });
  }

  render() {
    const { t } = this.props;
    //  if (this.state.redirectToReferrer == true) {
    //var link = "/contact";
    //window.location.replace(link);
    //   window.location.reload();
    //  } else {
    return (
      <Transition.Root show={this.props.showModal} as={Fragment}>
        <Dialog
          as="div"
          static
          className="fixed z-10 inset-0 overflow-y-auto"
          open={this.state.open}
          onClose={this.props.handleClose}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className=" dark:bg-gray-800 dark:text-white inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                  <ToastContainer delay={3000} position={"top-right"} />

                  <button
                    type="button"
                    className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                    onClick={this.props.handleClose}
                  >
                    <span className="sr-only">Close</span>
                    <XIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
                <div className="sm:flex sm:items-start">
                  <div className="dark:text-white dark:bg-gray-400 mx-auto flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
                      />
                    </svg>
                  </div>
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <Dialog.Title
                      as="h3"
                      className="dark:text-white text-lg leading-6 font-medium text-gray-900"
                    >
                      {t("addcontact")}
                    </Dialog.Title>
                  </div>
                </div>

                <div className="mt-10 sm:mt-0 ">
                  <div className="mt-5 md:mt-0 md:col-span-1">
                    <form onSubmit={this.onSubmit}>
                      <div className="overflow-hidden sm:rounded-md">
                        <div className="px-4 py-5 bg-white sm:p-6 dark:bg-gray-800 dark:text-white ">
                          <div className="grid grid-cols-6 gap-6">
                            <div className="col-span-6 sm:col-span-3">
                              <label
                                htmlFor="first-name"
                                className="dark:text-white block text-sm font-medium text-gray-700"
                              >
                                {t("Nom.contact.table")}
                                <sup className="text-red-500">*</sup>
                              </label>
                              <input
                                value={this.state.nom}
                                type="text"
                                name="nom_prenom"
                                id="nom_prenom"
                                onChange={(e) =>
                                  this.onChangeState("nom", e.target.value)
                                }
                                autoComplete="given-name"
                                className="px-2 py-1 mt-1 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-gray-300 rounded-md border"
                              />
                            </div>

                            <div className="col-span-6 sm:col-span-3">
                              <label
                                htmlFor="sur-name"
                                className="dark:text-white block text-sm font-medium text-gray-700"
                              >
                                {t("Prenom.contact.table")}
                              </label>
                              <input
                                value={this.state.nom_prenom}
                                type="text"
                                name="prenom"
                                id="prenom"
                                onChange={(e) =>
                                  this.onChangeState("prenom", e.target.value)
                                }
                                autoComplete="given-name"
                                className="px-2 py-1 mt-1 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-gray-300 rounded-md border"
                              />
                            </div>

                            <div className="col-span-6 sm:col-span-3">
                              <label
                                htmlFor="last-name"
                                className="dark:text-white block text-sm font-medium text-gray-700"
                              >
                                Mobile
                                <sup className="text-red-500">*</sup>
                              </label>
                              <input
                                value={this.state.tel_portable}
                                type="text"
                                name="tel_portable"
                                id="tel_portable"
                                onChange={(e) => {
                                  if (!isNaN(e.target.value))
                                    this.onChangeState(
                                      "tel_portable",
                                      e.target.value
                                    );
                                }}
                                autoComplete="family-name"
                                className="px-2 py-1 mt-1 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-gray-300 rounded-md border"
                              />
                            </div>

                            <div className="col-span-6 sm:col-span-3">
                              <label
                                htmlFor="email-address"
                                className="dark:text-white block text-sm font-medium text-gray-700"
                              >
                                E-mail
                              </label>
                              <input
                                value={this.state.email}
                                type="email"
                                name="email"
                                id="email"
                                onChange={(e) =>
                                  this.onChangeState("email", e.target.value)
                                }
                                autoComplete="email"
                                className="px-2 py-1 mt-1 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-gray-300 rounded-md border"
                              />
                            </div>

                            <div className="col-span-6 sm:col-span-3">
                              <label
                                htmlFor="street-address"
                                className="dark:text-white block text-sm font-medium text-gray-700"
                              >
                                {t("adress.contact.table")}
                              </label>
                              <input
                                value={this.state.adresse}
                                type="text"
                                name="adresse"
                                id="adresse"
                                onChange={(e) =>
                                  this.onChangeState("adresse", e.target.value)
                                }
                                autoComplete="street-address"
                                className="px-2 py-1 mt-1 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 border border-gray-300  focus:border-transparent  focus:ring-green-300 rounded-md"
                              />
                            </div>

                            <div className="col-span-6 sm:col-span-3">
                              <label
                                htmlFor="city"
                                className="dark:text-white block text-sm font-medium text-gray-700"
                              >
                                {t("tel")}
                              </label>
                              <input
                                value={this.state.tel_fix}
                                type="text"
                                name="tel_fix"
                                id="tel_fix"
                                onChange={(e) =>
                                  this.onChangeState("tel_fix", e.target.value)
                                }
                                className="px-2 mt-1 py-1 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 border border-gray-300  focus:border-transparent  focus:ring-green-300 rounded-md"
                              />
                            </div>

                            <div className="col-span-6 sm:col-span-3">
                              <label
                                htmlFor="state"
                                className="dark:text-white block text-sm font-medium text-gray-700"
                              >
                                {t("tel")} 2
                              </label>
                              <input
                                value={this.state.tel_3}
                                type="text"
                                name="tel_3"
                                id="tel_3"
                                onChange={(e) =>
                                  this.onChangeState("tel_3", e.target.value)
                                }
                                className="px-2 mt-1 py-1 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 border border-gray-300  focus:border-transparent  focus:ring-green-300 rounded-md"
                              />
                            </div>

                            <div className="col-span-6 sm:col-span-3">
                              <label
                                htmlFor="postal-code"
                                className="dark:text-white block text-sm font-medium text-gray-700"
                              >
                                {t("tel")} 3
                              </label>
                              <input
                                value={this.state.tel_4}
                                type="text"
                                name="tel_4"
                                id="tel_4"
                                onChange={(e) =>
                                  this.onChangeState("tel_4", e.target.value)
                                }
                                autoComplete="postal-code"
                                className="px-2 mt-1 py-1 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 border border-gray-300  focus:border-transparent  focus:ring-green-300 rounded-md"
                              />
                            </div>
                          </div>
                          <div className="flex items-center  mt-8 justify-between">
                            <p className="col-span-6 text-red-500 sm:col-span-3">
                              * Champs obligatoires !
                            </p>

                            <div className="px-6 py-4  sm:px-6">
                              <input
                                type="submit"
                                className="inline-flex cursor-pointer justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    );
  }
}
//}
export default withTranslation("common")(AddContact);
